import { render } from "./MetricCreate.vue?vue&type=template&id=642074e0&ts=true"
import script from "./MetricCreate.vue?vue&type=script&lang=ts"
export * from "./MetricCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__